// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"InfoCard_infoCard__2a15O","info":"InfoCard_info__3SVS1","center":"InfoCard_center__3srlT","right":"InfoCard_right__3EXIX"};